import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {BucketBrowserPage} from '@models/sidebar/response/bucket-browser-page';
import {TranslateService} from '@ngx-translate/core';
import {BucketBrowserFile} from '@models/pages/bucket-browser/bucket-browser-file';
import {DashboardLayouts} from '@models/dashboard/dashboard-layouts';

@Component({
    selector: 'scitis-bucket-browser-page-actions',
    templateUrl: './bucket-browser-page-actions.component.html',
    styleUrls: ['./bucket-browser-page-actions.component.scss'],
    standalone: false
})
export class BucketBrowserPageActionsComponent implements OnChanges {

  @Input()
  public bucketBrowserPageDetails: BucketBrowserPage | undefined = undefined;

  @Input()
  public searchItems: BucketBrowserFile[] = [];

  @Input()
  public hideCloseSearchButtonTimestamp: number = 0;

  @Output()
  public layoutUpdated: EventEmitter<DashboardLayouts> = new EventEmitter<DashboardLayouts>();

  @Output()
  public selectedItem: EventEmitter<BucketBrowserFile> = new EventEmitter<BucketBrowserFile>();

  @Output()
  public searchResultItemsUpdated: EventEmitter<BucketBrowserFile[]> = new EventEmitter<BucketBrowserFile[]>();

  @Output()
  public closeSearchTimestamp: EventEmitter<number> = new EventEmitter<number>();

  public bucketBrowserLayouts = DashboardLayouts;
  public layout: string = this.bucketBrowserLayouts.TILE;
  public searchMode = false;

  private basicSearchPlaceholder: string = '';
  private searchResultItems: BucketBrowserFile[] = [];

  constructor(private translate: TranslateService) {
    this.setTranslations();
  }

  get searchPlaceholder(): string {
    if (this.bucketBrowserPageDetails) {
      return `${this.basicSearchPlaceholder} ${this.bucketBrowserPageDetails.label}`;
    }
    return '';
  }

  get tileMode(): boolean {
    return this.layout === this.bucketBrowserLayouts.TILE;
  }

  get listMode(): boolean {
    return this.layout === this.bucketBrowserLayouts.LIST;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hideCloseSearchButtonTimestamp) {
      this.searchMode = false;
    }
  }

  select(selectedItem: BucketBrowserFile): void {
    this.selectedItem.emit(selectedItem);
  }

  onSearch(searchResultItems: BucketBrowserFile[]): void {
    this.searchResultItems = searchResultItems;
  }

  displaySearchResult(): void {
    this.searchResultItemsUpdated.emit(this.searchResultItems);
    this.searchMode = true;
  }

  selectLayout(layout: DashboardLayouts) {
    this.layout = layout;
    this.layoutUpdated.emit(layout);
  }

  closeSearch() {
    this.searchMode = false;
    this.closeSearchTimestamp.emit(new Date().getTime());
  }

  private setTranslations(): void {
    this.basicSearchPlaceholder = this.translate.instant('Search for files in');
  }

}
